import { Injectable } from "@angular/core";
import { GenericResponse } from '../business-entities/generic-response';
import { SelectListItemViewModel } from "../business-entities/select-list-item-view-model";
import { DealerHolidaySaveViewModel, DealerHolidayViewModel } from './../business-entities/dealer-holiday-list-view-model';
import { DealerHolidayDataService } from './../data-services/dealer-holiday-data.service';

@Injectable({
    providedIn: 'root'
})

export class DealerHolidayBusinessService {

    // dealerHolidayListViewModel: DealerHolidayViewModel[];
    // dealerHolidayViewModel: DealerHolidayViewModel;

    dealerId: string;
    dealerHolidayId: number = 0;
    isEdit:boolean = false;
    isAdd:boolean = false;
    dealerList: Array<SelectListItemViewModel>;



    constructor(private dealerHolidayDataService: DealerHolidayDataService) { }

    async getDealerHolidayList() {
        let dealerHolidayListViewModel: DealerHolidayViewModel[] = [];
        await this.dealerHolidayDataService
            .getDealerHolidayList()
            .then(
                (res: GenericResponse<Array<DealerHolidayViewModel>>) => {
                    dealerHolidayListViewModel = res.responseObject;
                }
            );
        return dealerHolidayListViewModel;
    }

    async getDealerWiseHolidayList(id:string) {
        let dealerHolidayListViewModel: Array<DealerHolidayViewModel> = [];
        await this.dealerHolidayDataService
            .getDealerWiseHolidayList(id)
            .then(
                (res: GenericResponse<Array<DealerHolidayViewModel>>) => {
                    dealerHolidayListViewModel = res.responseObject;
                }
            );
        return dealerHolidayListViewModel;
    }

    async getDealerHolidayDetails(dealerServiceId: number) {
        let dealerHolidayViewModel: DealerHolidayViewModel;
        await this.dealerHolidayDataService
            .getDealerHolidayDetails(dealerServiceId)
            .then(
                (res: GenericResponse<DealerHolidayViewModel>) => {
                    dealerHolidayViewModel = res.responseObject;
                }
            );
        return dealerHolidayViewModel;
    }

    addDealerHolidays(dealerHolidayViewModel: DealerHolidayViewModel): Promise<GenericResponse<DealerHolidayViewModel>> {
        return this.dealerHolidayDataService.addDealerHolidays(dealerHolidayViewModel);
    }

    editDealerHolidays(dealerHolidayViewModel: DealerHolidaySaveViewModel): Promise<GenericResponse<DealerHolidaySaveViewModel>> {
        return this.dealerHolidayDataService.editDealerHolidays(dealerHolidayViewModel);
    }

    deleteDealerHoliday(id: number) {
        return this.dealerHolidayDataService.deleteDealerHoliday(id);
    }

}